module.exports = __webpack_public_path__ + "static/media/2.ed01d0da.jpg";